import React, { useState, useEffect } from 'react';
import { Box, Fade, IconButton, useMediaQuery } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CarCard from './CarCard';
import { useTheme } from '@mui/material/styles';

const CarSlideShow = ({ cars }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // Change slide every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % cars.length);
    }, 3000);

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, [cars.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + cars.length) % cars.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % cars.length);
  };

  return (
    <Box
      position="relative"
      width="100%"
      height={isSmallScreen?'250px':'500px'}
      display="block"
      marginTop="60px"
      alignItems="center"
      justifyContent="center"
      sx={{
        '&:hover .navButton': {
          opacity: 1,
        },
      }}
    >
      {cars.map((car, index) => (
        <Fade
          key={car.id}
          in={index === currentIndex}
          timeout={{ enter: 500, exit: 500 }}
          unmountOnExit
        >
          <Box position="absolute" width="100%" height="80%"> {/* Adjust width/height to control card size */}
            <CarCard car={car} />
          </Box>
        </Fade>
      ))}

      {/* Left Arrow */}
      <IconButton
        onClick={handlePrev}
        className="navButton"
        sx={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          opacity: 0,
          transition: 'opacity 0.3s',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <ArrowBackIosIcon />
      </IconButton>

      {/* Right Arrow */}
      <IconButton
        onClick={handleNext}
        className="navButton"
        sx={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          opacity: 0,
          transition: 'opacity 0.3s',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          color: 'white',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
};

export default CarSlideShow;
